<template>
    <div>

        <fieldset>
            <div class="content-caption dashed font18 required dashed" style="background-color: #fff">
                <span><span class="color-laber"></span>需求详情</span>
            </div>
            <div class="form-layout">

                <div class="mb20">
                    <label class="mr20">
                        <el-checkbox v-model="goodsFlag">商品</el-checkbox>
                    </label>
                    <label class="mr20" v-if="!vendor">
                        <el-checkbox v-model="serviceFlag" hidden="hidden">服务</el-checkbox>
                    </label>
                </div>
                <el-form :model="callBidGoods" ref="callBidGoods" :rules="rules" label-width="100px" class="demo-ruleForm">
                    <div v-if="goodsFlag">
                        <table class="custom-tbl">
                            <thead class="head">
                            <tr class="row">
                                <th width="">产品名称</th>
                                <th width="100">采购数量</th>
                                <th>单位</th>
                                <th>质保期(月)</th>
                                <th width="40%">商品描述</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(callBidGoods, index) in callBidDoc.callBidGoodsList">
                                <td>
                                    <el-form-item :prop="'callBidGoodsList.' + index + '.name'">
                                        <el-input v-model="callBidGoods.name"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="'callBidGoodsList.' + index + '.quantity'">
                                        <el-input v-model="callBidGoods.quantity"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="'callBidGoodsList.' + index + '.unit'">
                                        <el-input v-model="callBidGoods.unit"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="'callBidGoodsList.' + index + '.wrntPeriod'">
                                        <el-input v-model="callBidGoods.wrntPeriod"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="'callBidGoodsList.' + index + '.desc'">
                                        <el-input v-model="callBidGoods.desc"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <a class="swb-btn-link" @click="deleteTplVar(index)">移除</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr class="row">
                                <td colspan="6">
                                    <div class="swb-btn-link" @click="showInput()">
                                        <i class="icon iconfont icon-jiahao"></i><span>添加商品</span>
                                    </div>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </el-form>
                <el-form :model="callBidServc" ref="callBidServc" :rules="rules" label-width="100px" class="demo-ruleForm">
                    <div v-if="serviceFlag">
                        <table class="custom-tbl">
                            <thead class="head">
                            <tr class="row">
                                <th width="">服务名称</th>
                                <th width="60%">服务描述</th>
                                <th>操作</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(callBidServc,index) in callBidDoc.callBidServcList">
                                <td>
                                    <el-form-item :prop="'callBidServcList.' + index + '.name'">
                                        <el-input v-model="callBidServc.name"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <el-form-item :prop="'callBidServcList.' + index + '.desc'">
                                        <el-input v-model="callBidServc.desc"></el-input>
                                    </el-form-item>
                                </td>
                                <td>
                                    <a class="swb-btn-link" @click="deleteTplVar1(index)">移除</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr class="row">
                                <td colspan="3" class="align center" style="padding: 10px; border: 1px solid #eee; text-align: center;">
                                    <div class="swb-btn-link" @click="showInput1()">
                                        <i class="icon iconfont icon-jiahao"></i><span>添加服务</span>
                                    </div>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </el-form>
            </div>
        </fieldset>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import callBidApi from '../../api/callBid'

    import SwbOrientationBidList from './OrientationBidList';
    Vue.regist(SwbOrientationBidList);

    export default{
        name: 'swb-create-call-item',
        desc: '创建招标书添加商品和服务组件',
        props: ['id', 'vendor'],
        data: function () {
            var checkName = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };

            var checkquantity = (rule, value, callback) => {
                if(Utils.isNoB(value)) {
                    callback(new Error('数量不可为空'));
                } else if(!Utils.isNumber(value)) {
                    callback(new Error('数量必须为数字'));
                } else {
                    callback();
                }
            };

            return {
                name: null,
                desc: null,
                quantity: null,
                unit: null,
                name1: null,
                desc1: null,
                callBidDoc: {
                    callBidGoodsList: [],
                    callBidServcList: [],
                },
                callBidGoods: null,
                callBidServc: null,
                serviceFlag: false,
                goodsFlag: false,

                rules: {
                    name: [
                        {validator: checkName, trigger: 'blur'}
                    ],
                    quantity: [
                        {validator: checkquantity, trigger: 'blur'}
                    ],
                    unit: [
                        {validator: checkName, trigger: 'blur'}
                    ]
                }
            }
        },
        created: function () {
            let id = this.id;

            if(null != id) {
                this.getCallBidServc(id);
                this.getCallBidGoods(id);
            }
        },

        methods: {
            validateQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请数量'));
                } else {
                    if(!Utils.isNumber(value) || value <= 0) {
                        callback(new Error('请输入大于0的数字'));
                    } else {
                        callback();
                    }
                }
            },
            validateName: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入商品名称'));
                }
            },
            validateUtit: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入单位'));
                }
            },
            validateGoods:function (row) {
                let result = {
                    message : null,
                };
                if(Utils.isNoB(row.name)){
                    result.message = "商品名称不能为空";
                }
                if(Utils.isNoB(row.quantity)){
                    result.message = "价格不能为空";
                } else {
                    if(!Utils.isNaturalStr(row.quantity, true)) {
                        result.message = "采购数量错误";
                    }
                }
                if(Utils.isNoB(row.unit)){
                    result.message ="单位不能为空";
                }
                if(Utils.isNoB(row.wrntPeriod)){
                    result.message = "质保期不能为空";
                } else if(!Utils.isNaturalStr(row.wrntPeriod, true)) {
                    result.message = "质保期错误";
                }
                if(!Utils.isNoB(result.message)){
                    result.type = "warn";
                }else{
                    result.type = "info";
                }
                return result;
            },

            validateServc:function (row) {
                let result = {};
                if(Utils.isNoB(row.name)){
                    result.type = "warn";
                    result.message = "服务名称不能为空";
                }else{
                    result.type = "info";
                }
                return result;
            },
            showDialog: function (data) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "需求项列表",
                    width: 945,
                    height: 600,
                    centerButtons: false,
                    showCloseBtn: true,
                    cancelVisible: false,
                    okVisible: false,
                    template: '<div><swb-orientation-bid-list  ref="swb_orientation_bid_list"></swb-orientation-bid-list>' +
                    '</div>',
                    data: {
                        loading: false,
                    },
                });
            },

            deleteTplVar: function (index) {
                let self = this;
                self.callBidDoc.callBidGoodsList.splice(index, 1);
                self.callBidDoc = Utils.merge({}, self.callBidDoc);
            },

            showInput: function () {
                let self = this;
                let tplvar = {};
                tplvar.text = null;
                tplvar.value = null;
                self.callBidDoc.callBidGoodsList.push(tplvar);
                self.callBidDoc = Utils.merge({}, self.callBidDoc);
            },

            showInput1: function () {
                let self = this;
                let tplvar1 = {};
                tplvar1.text = null;
                tplvar1.value = null;
                self.callBidDoc.callBidServcList.push(tplvar1);
                self.callBidDoc = Utils.merge({}, self.callBidDoc);
            },

            deleteTplVar1: function (index) {
                let self = this;
                self.callBidDoc.callBidServcList.splice(index, 1);
                self.callBidDoc = Utils.merge({}, self.callBidDoc);
            },

            getSelFlags(){
                return {
                    goods: this.goodsFlag,
                    servc: this.serviceFlag
                };
            },

            getDlgResultGoods: function () {
                let self = this;
                let result = {};
                //
                if(self.goodsFlag) {
                    let callBidGoodsList = self.callBidDoc.callBidGoodsList;
                    if(callBidGoodsList != null && callBidGoodsList.length > 0) {
                        result.type = 'info';
                        result.callBidGoodsList = callBidGoodsList;
                    }
                }
                //
                return result;
            },
            getDlgResultService: function () {
                let self = this;
                let result = {};
                //
                if(self.serviceFlag) {
                    let callBidServcList = self.callBidDoc.callBidServcList;
                    if(callBidServcList != null && callBidServcList.length > 0) {
                        result.type = 'info';
                        result.callBidServcList = callBidServcList;
                    }
                }
                return result;
            },

            getCallBidGoods: function (id) {
                let self = this;
                let filterItems = {};
                filterItems.docId = id;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidGoodsList(filterItems, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let callBidGoodsList = result.data;
                        if(callBidGoodsList != null && callBidGoodsList.length > 0) {
                            for(var i = 0; i < callBidGoodsList.length; i++) {
                                let callBidGoods = callBidGoodsList[i];
                            }
                            self.callBidDoc.callBidGoodsList = callBidGoodsList;
                            self.goodsFlag = true;
                        } else {
                            self.goodsFlag = false;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getCallBidServc: function (id) {
                let self = this;
                let filterItems = {};
                filterItems.docId = id;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidServcList(filterItems, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let callBidServcList = result.data;
                        if(callBidServcList != null && callBidServcList.length > 0) {
                            self.callBidDoc.callBidServcList = callBidServcList;
                            self.serviceFlag = true;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/CreateCallItem.vue